import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { JsonEditorComponent } from '@components/misc/json-editor/json-editor.component';
import { clone } from 'lodash';
import { AutosizeModule } from 'ngx-autosize';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PanelModule } from 'primeng/panel';
import { TextareaModule } from 'primeng/textarea';

import { VideoClipEditorData } from '../../video-clip/video-clip-editor/video-clip-editor.component';
import { VideoShotFormControl } from '../../video-project.form';
import { JsonPromptExample, JsonPromptSchema } from './definitions';

export interface VideoShotEditorData {
  shot: FormGroup<VideoShotFormControl>;
}

@Component({
  selector: 'app-video-shot-edit',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextareaModule,
    AutosizeModule,
    PanelModule,
    ButtonModule,
    JsonEditorComponent,
  ],
  templateUrl: './video-shot-editor.component.html',
  styleUrl: './video-shot-editor.component.scss',
})
export class VideoShotEditorComponent {
  get shot() {
    return this.config.data.shot;
  }

  get jsonPrompt() {
    return this.shot.value.jsonPrompt;
  }

  set jsonPrompt(value: Record<string, any>) {
    this.shot.patchValue({ jsonPrompt: value });
  }

  get jsonPromptSchema() {
    return JsonPromptSchema;
  }

  constructor(
    private readonly config: DynamicDialogConfig<VideoShotEditorData>,
  ) {}

  onCreateJsonPromptClick() {
    this.shot.setControl(
      'jsonPrompt',
      new FormControl(clone(JsonPromptExample), { nonNullable: true }),
    );
  }

  onResetJsonPromptClick() {
    this.jsonPrompt = clone(JsonPromptExample);
  }

  onDeleteJsonPromptClick() {
    this.shot.setControl('jsonPrompt', new FormControl(null));
  }
}

@Component({
  selector: 'app-video-shot-editor-footer',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `
    <div class="flex items-center space-x-2 mt-3">
      @if (config.data?.hasChanges()) {
        <p-button
          type="button"
          label="Reset"
          severity="warn"
          icon="pi pi-undo"
          (onClick)="this.ref.close('reset')" />
      }
      <p-button
        type="button"
        label="Done"
        icon="pi pi-check"
        (click)="this.ref.close()" />
    </div>
  `,
})
export class VideoShotEditorFooterComponent {
  constructor(
    readonly ref: DynamicDialogRef,
    readonly config: DynamicDialogConfig<VideoClipEditorData>,
  ) {}
}
